/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Button } from "@mui/material";
import { useAllCollapsed } from "cms/common/context/all-collapsed";
import { useTranslation } from "react-i18next";

/**
 * @type {import('react').FC<ExpandCollapseContentZoneProps>}
 */
const ExpandCollapseContentZone = (props) => {
    
    const { t } = useTranslation();
    const active = props?.active;
    const disabled = props?.disabled;

    const { expandAll, collapseAll } = useAllCollapsed();

    return (
        <div className={"flex-row expand-collapse-fields"} style={{ marginBottom: "12px" }}>
            {active && (
                <div className='flex-row-end' style={{ flex: "1" }}>
                    <Button onClick={expandAll} disabled={disabled}>
                        {t("commons.expandAll")}
                    </Button>
                    <div
                        style={{
                            paddingTop: "6px",
                            paddingBottom: "6px",
                            color: "#b4b4b4",
                        }}
                    >
                        |
                    </div>
                    <Button
                        onClick={collapseAll}
                        disabled={disabled}
                        style={{ marginRight: "-8px" }}
                    >
                        {t("commons.collapseAll")}
                    </Button>
                </div>
            )}
        </div>
    );
};

export { ExpandCollapseContentZone };

/**
 * @typedef {object} ExpandCollapseContentZoneProps
 * @property {boolean} active
 * @property {boolean} disabled
 */
